import { render } from "./kalio-comments.vue?vue&type=template&id=952b1b06"
import script from "./kalio-comments.vue?vue&type=script&lang=js"
export * from "./kalio-comments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__